import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../img/logo.png';
import CourseMenu from './CourseMenu';

const Header = () => {
    return (
        <div className='sticky top-0 z-30 '>
            <div className="navbar p-0 bg-slate-200 px-2 pb-1">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex="0" className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            <li><Link to='/home' className='md:bg-orange-400 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded'>Home</Link></li>
                            <li><Link to='/about-us' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded'>About Us</Link></li>
                            <li><Link to='/contact-us' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded' >Contact Us</Link></li>
                            <li><Link to='/career' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded'>Counselor</Link></li>
                            <li><Link to='/blog' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded'>Blog</Link></li>
                            <li><Link to='/courses' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded' >Our Courses</Link></li>

                            <li><button className='md:bg-green-400 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded block md:hidden text-left'>Login/Sign Up</button></li>
                        </ul>
                    </div>
                    <div className='md:flex justify-center hidden'>
                        <img className='h-16' src={logo} alt="" />
                        <div className='my-auto'>
                            <h2 className='my-auto font-bold text-xl text-blue-600'>Career <span className='text-orange-500'>Hikers</span> </h2>
                            <p className='text-blue-900 font-medium text-sm ml-6'>Way To Success</p>
                        </div>
                    </div>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0">
                        <li><Link to='/home' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded' >Home</Link></li>
                        <li><Link to='/about-us' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded' >About Us</Link></li>
                        <li><Link to='/contact-us' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded' >Contact Us</Link></li>
                        <li><Link to='/career' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded' >Career</Link></li>
                        <li><Link to='/blog' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded' >Blog</Link></li>
                        <li><Link to='/courses' className='md:bg-orange-500 p-1 md:text-white font-semibold mr-2 px-2 py-1 rounded' >Our Courses</Link></li>
                    </ul>
                </div>
                <div className="navbar-end">
                    <input type="text" placeholder='Search' className='mr-2 outline-none p-1 rounded hidden md:flex' />
                    <button className='bg-green-400 text-white rounded py-1 px-2 font-semibold md:flex hidden'>Login/Sign Up</button>
                    <div className='flex justify-center md:hidden'>
                        <img className='h-16' src={logo} alt="" />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Header;